import { render, staticRenderFns } from "./MyExam.vue?vue&type=template&id=50d9e0dd&scoped=true&"
import script from "./MyExam.vue?vue&type=script&lang=js&"
export * from "./MyExam.vue?vue&type=script&lang=js&"
import style0 from "./MyExam.vue?vue&type=style&index=0&id=50d9e0dd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d9e0dd",
  null
  
)

export default component.exports